import React, { useEffect, useState } from "react";
import { format } from "date-fns-tz";
import { Clock, Store } from "lucide-react";
import { BrazilDate } from "../../../../utils/BrazilDate";

interface HeaderProps {
  dateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

function formatClockBr(): string {
  const timezone = BrazilDate.getTimezone();
  return format(BrazilDate.now(), "HH:mm:ss", { timeZone: timezone });
}

export const Header: React.FC<HeaderProps> = ({
  dateLabel,
  selectedLojaId,
  selectedLojaNome,
}) => {
  const [clock, setClock] = useState(() => formatClockBr());

  useEffect(() => {
    const id = window.setInterval(() => {
      setClock(formatClockBr());
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="mt-6 px-4 py-4 text-center sm:py-6">
      <h1 className="mb-2 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-2xl font-black text-transparent sm:text-3xl md:text-4xl lg:text-5xl">
        RETIRADA NO BALCÃO
      </h1>
      <div className="mb-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm opacity-75 sm:text-lg">
        <Clock className="h-3 w-3 shrink-0 sm:h-4 sm:w-4" aria-hidden />
        <span>{dateLabel}</span>

        <span
          className="font-semibold tabular-nums tracking-tight"
          aria-live="polite"
          aria-atomic
          aria-label="Horário de Brasília"
        >
          {clock}
        </span>
        {selectedLojaId && selectedLojaNome && (
          <>
            <span className="mx-1 hidden shrink-0 sm:mx-2 sm:inline">•</span>
            <span className="flex w-full shrink-0 items-center justify-center gap-2 sm:mx-0 sm:inline-flex sm:w-auto">
              <Store className="h-3 w-3 shrink-0 sm:h-4 sm:w-4" aria-hidden />
              <span>{selectedLojaNome}</span>
            </span>
          </>
        )}
      </div>
    </div>
  );
};
